import { actionTypes } from '../constants/AnalyticsGa4Constants';

const setSdkConfig = payload => {
  return {
    type: actionTypes.SET_SDK_CONFIG,
    payload
  };
};

const trackContentClick = ({ eventEntity, uiEntity }) => {
  return {
    type: actionTypes.TRACK_CONTENT_CLICK,
    payload: {
      event: eventEntity,
      ui: uiEntity
    }
  };
};

const trackPageView = ({ bibId, list }) => {
  return {
    type: actionTypes.TRACK_PAGE_VIEW,
    payload: {
      bibId,
      list
    }
  };
};

const trackSdkCheckoutPlace = bibEntity => {
  return {
    type: actionTypes.TRACK_SDK_CHECKOUT_PLACE,
    payload: {
      bib: bibEntity
    }
  };
};

const trackSdkHoldPlace = bibEntity => {
  return {
    type: actionTypes.TRACK_SDK_HOLD_PLACE,
    payload: {
      bib: bibEntity
    }
  };
};

const trackSdkLogin = userEntity => {
  return {
    type: actionTypes.TRACK_SDK_LOG_IN,
    payload: {
      user: userEntity
    }
  };
};

const trackSdkUserAccountRegister = () => {
  return {
    type: actionTypes.TRACK_SDK_USER_ACCOUNT_REGISTER
  };
};

export {
  setSdkConfig,
  trackContentClick,
  trackPageView,
  trackSdkCheckoutPlace,
  trackSdkHoldPlace,
  trackSdkLogin,
  trackSdkUserAccountRegister
};
